import { getMallConfig } from '../api/config';
import { getMallBasicInfoByIds } from '../api/merchant';
import { AdInfo, DpInfo, MallInfo, MallThemeInfo } from '../type';

/** 获取商圈列表信息 */
export async function getMallThemeInfoList(): Promise<MallThemeInfo[]> {
  const config = await getMallConfig();
  const basicInfos = await getMallBasicInfos(config);
  return config.map(cfg => ({
    dpInfo: formatDpInfo(cfg),
    mallInfo: formatMallInfo(cfg, basicInfos),
    adInfo: formatAdInfo(cfg),
  }));
}

function formatDpInfo(cfg): DpInfo {
  const { dpId, id }: Record<string, string> = cfg;
  return { dpId, themeId: id };
}

/** 格式化商圈信息 */
function formatMallInfo(cfg, basicInfos: Array<{
  id: string,
  name: string,
  logo: string
}>): MallInfo {
  const { id, desc, addr, bgColor, bgImgUrl }: Record<string, string> = cfg;
  const baseInfo = basicInfos.find(item => item.id === id);
  return {
    id,
    name: baseInfo!.name,
    logo: baseInfo!.logo,
    desc,
    addr,
    bgColor,
    bgImgUrl,
  };
}

/** 格式化商圈广告信息 */
export function formatAdInfo(cfg): AdInfo | undefined {
  const { jumpUrl = '', imgUrl = '' }: Record<string, string> = cfg;
  if (!cfg.needAD) return;
  return {
    jumpUrl,
    imgUrl,
  };
}

async function getMallBasicInfos(cfg) {
  const spidList: string[] = cfg.map(item => item.id);
  if (!spidList.length) return [];
  return await getMallBasicInfoByIds(spidList);
}
